import { prepareHtml } from 'core/common/utils/prepareHtml';
import { ReviewCard as ReviewCardType } from 'core/flow/entities/Content';
import {
  BadgeStyled,
  DateStyled,
  FooterStyled,
  MessageStyled,
  WrapperStyled,
  UserNameStyled,
  RatingStarsStyled,
  VerifiedTextStyled,
  UserNameWrapperStyled,
} from './styled';

type ReviewCardProps = ReviewCardType;

export const ReviewCard = ({ date, review, verified, userName }: ReviewCardProps) => {
  return (
    <WrapperStyled>
      <RatingStarsStyled defaultValue={5} readOnly />
      <MessageStyled variant="bodyMediumRegular" dangerouslySetInnerHTML={prepareHtml(review)} />
      <UserNameWrapperStyled>
        <UserNameStyled
          variant="bodyMediumSemiBold"
          dangerouslySetInnerHTML={prepareHtml(userName)}
        />
        <BadgeStyled src={verified.icon.src} alt={verified.icon.alt} width={20} height={20} />
      </UserNameWrapperStyled>
      <FooterStyled>
        <VerifiedTextStyled
          color="secondary"
          variant="bodySmallRegular"
          dangerouslySetInnerHTML={prepareHtml(verified.text)}
        />
        <DateStyled variant="bodySmallRegular" dangerouslySetInnerHTML={prepareHtml(date)} />
      </FooterStyled>
    </WrapperStyled>
  );
};
